/**
 * Created by Yoyo on 05/26/2020.
 * ------ maintenance history ------
 * update Todd Yu on 07/10/2020
 * Add routing for Admin Pages
 */

import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { SettingsComponent } from './settings.component';
import { FlatFileManagementComponent } from '../../components/flat-file/flat-file-management.component';
import { ManageScreensComponent } from '../../components/manage-screens/manage-screens.component';
import { AdvancedSettingComponent } from './advanced-setting.component';
import { SettingsGuard } from './settings.guard';

const routes: Routes = [
    {
        path: '',
        component: SettingsComponent,
        canActivate: [],
        children: [
            { path: 'data', component: FlatFileManagementComponent },
            { path: 'screens', component: ManageScreensComponent },
            { path: 'advanced', component: AdvancedSettingComponent },
            {
                path: 'admin-console',
                loadChildren: () => import('../../components/admin-pages/admin-page.module').then(m => m.AdminPageLayoutModule),
                canActivate: [SettingsGuard]
            },
            { path: '', redirectTo: 'admin-console', pathMatch: 'full' }
        ]
    },
];

@NgModule({
    imports: [RouterModule.forChild(routes)],
    exports: [RouterModule]
})
export class SettingsRoutingModule { }
